const K1 = 1.2;
const B = 0.75;
function tokenise(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .split(/\s+/)
        .filter((t) => t.length > 0);
}
export function bm25Search(query, index, documents, k = 20) {
    const queryTokens = tokenise(query);
    const N = index.stats.totalDocuments;
    const avgdl = index.stats.averageDocumentLength;
    const scores = new Map();
    for (const token of queryTokens) {
        const postings = index.terms[token];
        if (!postings)
            continue;
        const df = postings.length;
        const idf = Math.log((N - df + 0.5) / (df + 0.5));
        for (const docId of postings) {
            const doc = index.documents[docId];
            if (!doc)
                continue;
            const tf = 1;
            const score = idf * (tf * (K1 + 1)) / (tf + K1 * (1 - B + B * doc.length / avgdl));
            scores.set(docId, (scores.get(docId) ?? 0) + score);
        }
    }
    const results = [];
    for (const [docId, score] of scores) {
        const doc = documents[docId];
        if (doc) {
            results.push({ docId, score, code: doc.code });
        }
    }
    results.sort((a, b) => b.score - a.score);
    return results.slice(0, k);
}
//# sourceMappingURL=bm25.js.map